import { Controller } from "@hotwired/stimulus"

// Copies a value (e.g. an email message_id) to the clipboard and briefly shows a
// tick. Calls preventDefault + stopPropagation so a copy click nested near a
// <summary>/<details> never toggles the expander.
export default class extends Controller {
  static values = { text: String }

  copy(event) {
    event.preventDefault()
    event.stopPropagation()

    const button = event.currentTarget
    const done = () => {
      const original = button.innerHTML
      button.innerHTML = '<i class="bi bi-check2"></i>'
      setTimeout(() => { button.innerHTML = original }, 1200)
    }

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(this.textValue).then(done).catch(() => {})
    }
  }
}
